import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grafanaContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_LoadingSpinner, null, null, 512), [
      [_vShow, !_ctx.iframeLoaded]
    ]),
    _withDirectives(_createElementVNode("iframe", {
      name: "external-iframe",
      id: "external-iframe",
      src: "/grafana/?orgId=2&kiosk",
      width: "100%",
      height: "100%",
      frameborder: "0",
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args)))
    }, null, 544), [
      [_vShow, _ctx.iframeLoaded]
    ])
  ]))
}